import { render, staticRenderFns } from "./Discover.vue?vue&type=template&id=9e60e5be&scoped=true&"
var script = {}
import style0 from "./Discover.vue?vue&type=style&index=0&id=9e60e5be&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e60e5be",
  null
  
)

export default component.exports